import React from "react";
import PropTypes from "prop-types";

const BusySpinner = ({ size, color }) => {
  return (
    <div className="spinner">
      <div
        className="bounce1"
        style={{
          backgroundColor: color || "white",
          height: size || "1rem",
          width: size || "1rem",
        }}
      ></div>
      <div
        className="bounce2"
        style={{
          backgroundColor: color || "white",
          height: size || "1rem",
          width: size || "1rem",
        }}
      ></div>
      <div
        className="bounce3"
        style={{
          backgroundColor: color || "white",
          height: size || "1rem",
          width: size || "1rem",
        }}
      ></div>
    </div>
  );
};

BusySpinner.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
};

export default BusySpinner;
